import {CreateFolderForm} from './CreateAssetFolderModal.types';
import {object, string} from 'yup';

const addFolderInitialValue: CreateFolderForm = {
  name: '',
};

const addFolderValidationSchema = object({
  name: string().nullable().required('Please fill folder name'),
});

export {addFolderValidationSchema, addFolderInitialValue};
